if ($(window).width() < 990 && $('body').hasClass('template-collection-brand-blocks-main')) {
    $('#product-grid .card-brand-block:not(.last-product-brand-block)').each(function (i) {
        $(this).addClass('editorial--block-' + (i + 1));
    });

    $('main #product-grid .plp-product-standard:not(.brand-block-grid-collection-product)').each(function (i) {
        $(this).addClass('product--block-' + (i + 1));
    });

    $('.editorial--block-1').insertAfter('.product--block-2');

    $('.editorial--block-2').insertAfter('.product--block-4');

    $('.editorial--block-3').insertAfter('.product--block-6');

    $('.editorial--block-4').insertAfter('.product--block-8');

    $('.editorial--block-5').insertAfter('.product--block-10');

    $('.editorial--block-6').insertAfter('.product--block-12');

    $('.editorial--block-7').insertAfter('.product--block-14');

    $('.editorial--block-8').insertAfter('.product--block-16');
} else if (
    $(window).width() < 990 &&
    $('body').hasClass('template-collection-brand-blocks') &&
    !$('body').hasClass('gifts-collection') &&
    !$('body').hasClass('grouped-collection-area')
    ) {
        
    $('#product-grid .card-brand-block:not(.last-product-brand-block)').each(function (i) {
        $(this).addClass('editorial--block-' + (i + 1));
    });

    $('main #product-grid .plp-product-standard:not(.brand-block-grid-collection-product)').each(function (i) {
        $(this).addClass('product--block-' + (i + 1));
    });

    //console.log('this fired');

        if ($('body').hasClass('brand-block-first-grid')) {
            $('.editorial--block-2').insertAfter('.product--block-6');
            $('.editorial--block-3').insertAfter('.product--block-12');
            $('.editorial--block-4').insertAfter('.product--block-20');
            $('.editorial--block-5').insertAfter('.product--block-26');
            $('.editorial--block-6').insertAfter('.product--block-34');
            $('.editorial--block-7').insertAfter('.product--block-40');
        } else if ($('body').hasClass('brand-block-first') && $('body').hasClass('sale-area') && !$('body').hasClass('small-brand-blocks-collection')) {

            console.log('this fired');

            $('.editorial--block-1').insertAfter('.product--block-4');
            $('.editorial--block-2').insertAfter('.product--block-11');
            $('.editorial--block-3').insertAfter('.product--block-18');
            $('.editorial--block-4').insertAfter('.product--block-25');
            $('.editorial--block-5').insertAfter('.product--block-32');
            $('.editorial--block-6').insertAfter('.product--block-39');
            $('.editorial--block-7').insertAfter('.product--block-46');
        } else if ($('body').hasClass('brand-block-first') && $('body').hasClass('small-brand-blocks-collection')) {
            if (isGiftGuideCollection) {
                $('.editorial--block-1').insertAfter('.product--block-4');
                $('.editorial--block-4').insertAfter('.product--block-16');
                $('.editorial--block-5').insertAfter('.product--block-20');
                $('.editorial--block-6').insertAfter('.product--block-24');
            } else {
                $('.editorial--block-3').insertAfter('.product--block-14');
                $('.editorial--block-4').insertAfter('.product--block-21');
                $('.editorial--block-5').insertAfter('.product--block-28');
                $('.editorial--block-6').insertAfter('.product--block-35');
                $('.editorial--block-7').insertAfter('.product--block-42');
            }

        } else {
            $('.brand-block-number-1:not(.last-product-brand-block)').insertAfter('.product--block-4');
            $('.brand-block-number-2:not(.last-product-brand-block)').insertAfter('.product--block-12');
            $('.brand-block-number-3:not(.last-product-brand-block)').insertAfter('.product--block-20');
            $('.brand-block-number-4:not(.last-product-brand-block)').insertAfter('.product--block-28');
            $('.brand-block-number-5:not(.last-product-brand-block)').insertAfter('.product--block-36');
            $('.brand-block-number-6:not(.last-product-brand-block)').insertAfter('.product--block-44');
            $('.brand-block-number-7:not(.last-product-brand-block)').insertAfter('.product--block-52');
            
        }
    
    

    setTimeout(function () {
        if (
            $('main .plp-product-standard').length == 5 &&
            $(window).width() < 991 &&
            $('body').hasClass('template-gift-finder')
        ) {
            $('.card-brand-block').insertAfter('main .product--block-5');
        }
    }, 100);

    //$('.editorial--block-1').insertAfter('.product--block-4');

}

$('main .brand-block-half').each(function (i) {
    $(this).addClass('brand-block-half-' + (i + 1));
});

if ($('body').hasClass('brand-block-first')) {
    setTimeout(function () {
        $('body').removeClass('plp--hide-brand-blocks');
    }, 400);
}

setTimeout(function () {
    $('body').removeClass('body-hidden');
}, 300);
